import React, { useMemo } from 'react';
import { Select } from '@chakra-ui/react';
import { COMMON_TIMEZONES, getGroupedTimeZones } from '../../utils/timezone';
import { useTimezone } from '../../contexts/TimezoneContext';

interface TimezoneSelectProps {
  size?: string;
  maxWidth?: Record<string, string> | string;
  width?: Record<string, string> | string;
  bg?: string;
}

/**
 * Display-timezone picker bound to the shared TimezoneContext.
 * Compact native <select>: common zones up top, then the full IANA list
 * grouped by region (with live UTC offsets).
 */
export const TimezoneSelect: React.FC<TimezoneSelectProps> = ({ size, maxWidth, width, bg }) => {
  const [timeZone, setTimeZone] = useTimezone();
  const groups = useMemo(() => getGroupedTimeZones(), []);

  return (
    <Select
      value={timeZone}
      onChange={(e) => setTimeZone(e.target.value)}
      size={size}
      maxWidth={maxWidth}
      width={width}
      bg={bg}
      aria-label="Display timezone"
    >
      <optgroup label="Common">
        {COMMON_TIMEZONES.map((tz) => (
          <option key={tz.value || 'local'} value={tz.value}>{tz.label}</option>
        ))}
      </optgroup>
      {groups.map((group) => (
        <optgroup key={group.region} label={group.region}>
          {group.options.map((tz) => (
            <option key={tz.value} value={tz.value}>{tz.label}</option>
          ))}
        </optgroup>
      ))}
    </Select>
  );
};
